import { gql } from "@apollo/client";
import { DeviceInfo } from "./getDeviceInfoCall";

export const MAINTAIN_DEVICE_INFO = gql`
  mutation MaintainDeviceInfo($domain: String!, $newDevices: [CreateDevice!]!, $updatedDevices: [MaintainDevice!]!) {
    device {
      maintainInfo(domain: $domain, newDevices: $newDevices, updatedDevices: $updatedDevices) {
        device_id
        name
        system_assignment
        lan_controller_id
        cpu_id
        power_supply
        max_ac_ports
      }
    }
  }
`

export interface MaintainDeviceInfoResponse {
  device: {
    maintainInfo: DeviceInfo[];
  }
}

export interface MaintainDeviceInfoParameters {
  domain?: string;
  updatedDevices: MaintainPanelDevice[];
  newDevices: CreatePanelDevice[];
}

export interface CreatePanelDevice {
  device_id?: number
  name?: String,
  system_assignment?: number,
  lan_controller_id?: number,
  cpu_id?: String,
  max_ac_ports?: number,
  power_supply?: number,
}

export interface MaintainPanelDevice {
  device_id: number,
  name?: String,
  system_assignment?: number,
  lan_controller_id?: number,
  cpu_id?: String,
  power_supply?: number,
  max_ac_ports?: number,
}
